export { default as SmartTalkTrialTicketCard } from './smart-talk-trial-ticket-card'
